import React from 'react';
import { Clock, User, X } from 'lucide-react';
import { useResidentSession } from '../utils/residentSession';
import Button from './ui/Button';

const ResidentSessionIndicator: React.FC = () => {
  const session = useResidentSession();

  if (!session.isActive) {
    return null;
  }

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <div className="flex items-center space-x-1">
            <User className="h-4 w-4 text-green-600" />
            <span className="text-sm font-medium text-green-800">
              Residente verificado: {session.name}
            </span>
          </div>
          <div className="flex items-center space-x-1">
            <Clock className="h-4 w-4 text-green-600" />
            <span className="text-xs text-green-600">
              {session.timeRemaining} restantes
            </span>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={session.clearSession}
          className="text-gray-500 hover:text-red-600 h-6 w-6 p-0"
          title="Cerrar sesión del residente"
        >
          <X className="h-3 w-3" />
        </Button>
      </div>
      <p className="text-xs text-green-600 mt-1">
        💡 Puede firmar/rechazar múltiples horometros sin necesidad de nuevos códigos
      </p>
    </div>
  );
};

export default ResidentSessionIndicator;
